import { apiClient } from '@/api/client'
import type { EstadisticasDetalladas, EstadisticasPorNewsletter } from '../types'

export async function fetchEstadisticasDetalladas(dias: number): Promise<EstadisticasDetalladas> {
  const { data } = await apiClient.get(`/enterprise-stats/detalladas/?dias=${dias}`)
  return data
}

export async function fetchEstadisticasPorNewsletter(
  anio: number,
  meses: string[],
): Promise<EstadisticasPorNewsletter> {
  const params = new URLSearchParams()
  params.set('anio', String(anio))
  params.set('meses', meses.join(','))
  const { data } = await apiClient.get(`/enterprise-stats/por-newsletter/?${params.toString()}`)
  return data
}
